<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      :selectionEnabled="false"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
    ></dx-grid>

    <v-dialog persistent v-model="createNew.dialog" max-width="600">
      <v-card class="pa-4">
        <v-form ref="formNew">
          <v-layout row>
            <v-card-title class="headline pl-0 pt-0 pb-2"
              >New {{
            }}</v-card-title>
          </v-layout>
          <div style="display: flex; align-items: center; gap: 8px;"></div>
          <v-text-field
            v-model="createNew.description"
            label="Description"
            placeholder="Enter a Description"
            outlined
            style="flex: 1;"
            :rules="[rules.required]"
          />

          <v-text-field
            v-model="createNew.link"
            label="Link"
            placeholder="Enter the link"
            outlined
            style="flex: 1;"
            :rules="[rules.pathOrUrl, rules.required]"
          />

          <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
            <v-spacer></v-spacer>

            <v-btn small color="default" dark @click="resetNew()">Cancel</v-btn>
            <v-btn small :loading="processing" color="success" @click="saveNew()">
              save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDetailsDialog" max-width="600" persistent>
      <v-card class="pa-4" v-if="selectedRow">
        <v-card-title class="headline pl-0 pt-0 pb-1">
          Information Details
          <span class="grey--text text--lighten-1 caption pl-2"
            >#{{ selectedRow.id }}</span
          >
        </v-card-title>
        <v-card-text class="grey--text text--darken-1 py-0">
          <div>
            Created By : {{ selectedRow.createBy }}, At :
            {{ formatDate(selectedRow.createAt) }}
          </div>
          <div v-if="selectedRow.lastUpdateBy || selectedRow.lastUpdatedAt">
            Update By : {{ selectedRow.lastUpdateBy }}, At :
            {{ formatDate(selectedRow.lastUpdatedAt) }}
          </div>
        </v-card-text>
        <v-divider class="mt-3"></v-divider>

        <v-card-text class="px-0, pb-1">
          <div v-if="!editMode">
            <div class="mb-3">
              <div style="word-wrap: break-word; overflow-wrap: break-word;">
                <span class="grey--text text--darken-1 mb-1"
                  >Description:
                </span>
                <span class="font-weight-bold">
                  {{ selectedRow.description }}
                </span>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="mb-3">
              <div style="word-wrap: break-word; overflow-wrap: break-word;">
                <span class="grey--text text--darken-1 mb-1">Link: </span>
                <span class="font-weight-bold">
                  <a
                    :href="selectedRow.link"
                    class="text-decoration-none"
                    @click.prevent="() => handleLinkClick(selectedRow.link)"
                  >
                    {{ selectedRow.link }}
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div v-else>
            <v-form ref="formEdit">
              <v-text-field
                v-model="edit.description"
                label="Description"
                placeholder="Enter a Description"
                outlined
                :rules="[rules.required]"
                class="mb-3"
              />

              <v-text-field
                v-model="edit.link"
                label="Link"
                placeholder="Enter the link"
                outlined
                :rules="[rules.pathOrUrl, rules.required]"
              />
            </v-form>
          </div>
        </v-card-text>

        <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
          <v-spacer></v-spacer>
          <template v-if="!editMode">
            <v-btn small color="default" dark @click="closeDetailsDialog"
              >Close</v-btn
            >
            <v-btn small color="error" @click="deleteDialog = true"
              >Delete</v-btn
            >
            <v-btn small color="success" @click="enterEditMode">Edit</v-btn>
          </template>
          <template v-else>
            <v-btn small color="default" dark @click="cancelEdit">Cancel</v-btn>
            <v-btn
              small
              :loading="processing"
              color="success"
              @click="saveChanges"
              >Save Changes</v-btn
            >
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline pb-0">Confirm Delete</v-card-title>
        <v-card-text>Are you sure you want to delete this item?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="default" dark @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn small color="error" :loading="processing" @click="softDelete"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },

  data: () => ({
    url: "",
    title: "Help Desk Information",
    actions: [],
    processing: false,
    copyURL: false,
    targetURL: true,
    selectedRow: null,
    showDetailsDialog: false,
    editMode: false,
    deleteDialog: false,
    createNew: {
      dialog: false,
      description: null,
      link: null,
    },

    edit: {
      link: null,
      description: null,
    },

    rules: {
      required: (value) => !!value || "Required.",
      pathOrUrl: (v) => {
        if (!v) return true;
        const isValidURL = URL.canParse(v);
        if (isValidURL) return isValidURL;
        return "Invalid link";
      },
    },
    columns: [
      {
        label: "Id",
        field: "id",
        visible: true,
        sortOrder: "asc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-50",
      },
      {
        label: "Description",
        field: "description",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-400",
      },
      {
        label: "Link",
        field: "link",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "href-action-cell-template",
        cssClass: "width-600",
      },
      {
        label: "Create By",
        field: "createBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-150",
      },
      {
        label: "Create Date",
        field: "createAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-150",
      },
    ],
  }),
  created() {
    const nameColumn = this.columns.find((c) => c.field === "link");
    if (nameColumn) {
      nameColumn.linkAction = (row) => {
        this.handleLinkClick(row.link);
      };
    }

    this.actions.push({
      text: "New",
      action: this.OpenCreateNewDialog,
    });
  },
  methods: {
    async beforeSetupGrid() {
      localStorage.getItem("help-desk-info-copy-url") == "true"
        ? (this.copyURL = true)
        : "";

      localStorage.getItem("help-desk-info-target-url") == "false"
        ? (this.targetURL = false)
        : "";

      this.url = `HelpDeskInformation`;

      this.actions.push({
        text: "URL ⚙️",
        type: "menu-switches",
        items: [
          {
            text: "Copy URL",
            value: this.copyURL,
            action: this.toggleCopyURL,
          },
          {
            text: "Open in new tab",
            value: this.targetURL,
            action: this.toggleTargetURL,
          },
        ],
      });
    },

    OpenCreateNewDialog() {
      this.createNew.dialog = true;
    },
    resetNew() {
      this.createNew = {
        dialog: false,
        description: null,
        link: null,
      };
      this.$refs.formNew.resetValidation(true);
    },
    async saveNew() {
      if (!this.$refs.formNew.validate(true)) {
        return;
      }

      this.processing = true;
      try {
        await this.$http.post("api/HelpDeskInformation/Create", {
          Description: this.createNew.description,
          Link: this.createNew.link,
        });
        this.$refs.grid.reloadGrid();
        this.processing = false;
        this.$notify({
          group: "notification",
          text: "New info created",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.resetNew();
      }
    },
    handleLinkClick(link) {
      try {
        const url = new URL(link);
        if (
          !this.copyURL &&
          (url.protocol == "http:" || url.protocol == "https:")
        ) {
          open(link, this.targetURL ? "_blank" : "_self");
          return;
        } else {
          this.copy(link);
        }
      } catch (error) {
        this.copy(link);
        console.log(error);
      }
    },
    async copy(link) {
      await navigator.clipboard.writeText(link);
      this.$notify({
        group: "notification",
        text: `Link copied to the clipboard`,
        type: "success",
      });
    },
    toggleCopyURL(v) {
      localStorage.setItem("help-desk-info-copy-url", v);
      this.copyURL = v;
    },
    toggleTargetURL(v) {
      localStorage.setItem("help-desk-info-target-url", v);
      this.targetURL = v;
    },
    onRowClicked(v) {
      this.selectedRow = v;
      this.showDetailsDialog = true;
    },
    closeDetailsDialog() {
      this.editMode = false;
      this.deleteDialog = false;
      this.resetEdit();
      if (this.$refs.formEdit) {
        this.$refs.formEdit.resetValidation(true);
      }
      this.showDetailsDialog = false;
      this.selectedRow = null;
    },
    formatDate(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      return d.toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    initializeEdit() {
      if (!this.selectedRow) return;
      this.edit.link = this.selectedRow.link;
      this.edit.description = this.selectedRow.description;
    },
    enterEditMode() {
      this.initializeEdit();
      this.editMode = true;
    },
    resetEdit() {
      this.edit = {
        link: null,
        description: null,
      };
    },
    cancelEdit() {
      this.editMode = false;
      this.resetEdit();
      if (this.$refs.formEdit) {
        this.$refs.formEdit.resetValidation(true);
      }
    },
    async saveChanges() {
      if (!this.$refs.formEdit.validate(true)) {
        return;
      }
      if (
        this.edit.link == this.selectedRow.link &&
        this.edit.description == this.selectedRow.description
      ) {
        return this.$notify({
          group: "notification",
          text: "No changes detected",
          type: "info",
        });
      }
      this.processing = true;
      try {
        await this.$http.put(
          `api/HelpDeskInformation/Update/${this.selectedRow.id}`,
          {
            Description: this.edit.description,
            Link: this.edit.link,
          }
        );
        this.$refs.grid.reloadGrid();
        this.$notify({
          group: "notification",
          text: "Info updated successfully",
          type: "success",
        });
        this.editMode = false;
        this.closeDetailsDialog();
      } catch (e) {
        console.error(e);
      } finally {
        this.processing = false;
        this.resetEdit();
      }
    },
    async softDelete() {
      try {
        this.processing = true;
        await this.$http.put(
          `api/HelpDeskInformation/SoftDelete/${this.selectedRow.id}`
        );
        this.$refs.grid.reloadGrid();
        this.$notify({
          group: "notification",
          text: "Info deleted",
          type: "success",
        });
        this.editMode = false;
        this.closeDetailsDialog();
        this.resetEdit();
      } catch (e) {
        console.error(e);
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>
